import { render, staticRenderFns } from "./myRequest.vue?vue&type=template&id=73ecad01"
import script from "./myRequest.vue?vue&type=script&lang=ts"
export * from "./myRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports